import React from 'react';
import { Form } from 'react-bootstrap';

export interface ClickableTextBoxProps {
    value: string,
    disabled: boolean,
    className?: string,
    onClick: () => void
}

function ClickableTextBox({ value, onClick, disabled, className = "" }: ClickableTextBoxProps) {
    return (
        <span style={{ position: "relative" }} >
            <Form.Control type="text" disabled value={value} className={className} />
            {!disabled &&
                <div style={{ position: "absolute", left: 0, right: 0, top: 0, bottom: 0, cursor: "pointer" }} onClick={onClick} />
            }
        </span>
    );
}

export default ClickableTextBox;